import { ReferralRoute } from '@/modules/referral/routes/referral.routes';
import ReferralSelfReferLayout from '@/modules/referral/pages/ReferralSelfReferLayout.vue';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  {
    path: '/',
    name: 'referral-external',
    component: ReferralSelfReferLayout,
    children: [
      {
        path: `/${ReferralRoute.VAULT_SELF_REFERRAL.path}`,
        name: `/${ReferralRoute.VAULT_SELF_REFERRAL.name}`,
        component: () =>
          import(
            '/@/modules/referral/components/stateful/flow/unprotected/ReferralSelfReferFlow_Start.vue'
          ),
        meta: { authOnly: false }
      }
    ]
  },
  {
    path: '/',
    name: 'settlement-referral-external',
    component: ReferralSelfReferLayout,
    children: [
      {
        path: `/${ReferralRoute.SETTLEMENT_SELF_REFERRAL.path}`,
        name: `/${ReferralRoute.SETTLEMENT_SELF_REFERRAL.name}`,
        component: () =>
          import(
            '/@/modules/referral/components/stateful/flow/unprotected/ReferralSelfReferFlow_Start.vue'
          ),
        meta: { authOnly: false }
      }
    ]
  }
];
